Revolution.Module.extend({
    NAME: "mde.bk-contact", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        this.emptyContactAdress();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },
    emptyContactAdress: function () {
        $('.bk-contact .address-details').each(function (index, elem) {
            // Si il n'y a rien au niveau de l'adresse
            if ($(elem).text().match(/\b(\w*)\b/) === null) {
                var $parentElem = $(elem).parent('.address-infos');

                $parentElem.find('.icon-pin').hide();
                $parentElem.parent('.address-wrapper').find('.address-title').css('marginBottom', 0);
            }
        });
    }
});
